import Header from './Header/Header';
import styles from './SignedInLayout.module.css';
import Footer from './Footer/Footer';

// The layout of the signed-in referral portals (aviva, generic, landg,
// landgci). The public default/healix sites use `Layout` (mainsite header,
// no auth section) instead.
export const SignedInLayout = (props: { children: any }) => {
  return (
    <div className={styles.layout}>
      <Header />
      {props.children}
      <Footer />
    </div>
  );
};
